"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const serialize_error_1 = require("serialize-error");
const getTime_1 = __importDefault(require("./getTime"));
const setLiveContextValues = (liveContext, context) => {
    return Object.entries(liveContext).reduce((acc, [key, val]) => {
        acc[key] = val();
        return acc;
    }, context);
};
const createLogject = (config, logArgs) => {
    return logArgs.reduce((result, arg, i) => {
        let nextPart;
        if (arg instanceof Error) {
            result.errors.push((0, serialize_error_1.serializeError)(arg));
            nextPart = `Error: ${arg.message}`;
        }
        else if (typeof arg === 'object') {
            nextPart = JSON.stringify(arg);
        }
        else {
            nextPart = arg;
        }
        if (nextPart) {
            if (i === 0) {
                result.message = nextPart;
            }
            else {
                result.message += ` ${nextPart}`;
            }
        }
        return result;
    }, {
        time: (0, getTime_1.default)(),
        timestamp: new Date().toISOString(),
        app: config.appName,
        level: {
            name: config.level.name.toUpperCase(),
            icon: config.level.icon,
            color: config.level.color,
        },
        name: config.name,
        context: setLiveContextValues(config.liveContext, config.context),
        errors: [],
        args: logArgs,
        message: '',
        session_id: config.sessionId,
    });
};
exports.default = createLogject;
//# sourceMappingURL=createLogject.js.map